(() => {
  const SELECTOR = '[data-ml-flow]';
  const ITEM_SELECTOR = '.ml-flow-reveal';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const revealImmediately = (section) => {
    section.classList.remove('ml-flow--motion');
    section.querySelectorAll(ITEM_SELECTOR).forEach((item) => item.classList.add('is-inview'));
  };

  const initSection = (section) => {
    if (!section || section.dataset.mlFlowReady === 'true') return;
    section.dataset.mlFlowReady = 'true';

    const items = [...section.querySelectorAll(ITEM_SELECTOR)];
    if (!items.length || reduceMotion.matches || !('IntersectionObserver' in window)) {
      revealImmediately(section);
      return;
    }

    section.classList.add('ml-flow--motion');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-inview');
        observer.unobserve(entry.target);
      });
    }, {
      root: null,
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.12
    });

    items.forEach((item) => observer.observe(item));
  };

  const initAll = (root = document) => {
    root.querySelectorAll(SELECTOR).forEach(initSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:select', (event) => {
    const section = event.target.querySelector?.(SELECTOR) || event.target.closest?.(SELECTOR);
    if (section) section.querySelectorAll(ITEM_SELECTOR).forEach((item) => item.classList.add('is-inview'));
  });
})();
